import axios from "axios";
import React, { Component } from "react";
import { Link } from "react-router-dom";
// get our fontawesome imports
import { faHeart, faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import SweetAlert from "react-bootstrap-sweetalert";
import LoadingScreen from "../components/LoadingScreen";
import Backsound from "../components/Backsound";

class WeddingDashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      musicName: "",
      musicURL: "",
      wedding: [],
      backsound: [],
      isReady: false,
      alert: null,
      message: null,
      errors: [],
    };
    this.handleLogout = this.handleLogout.bind(this);
    this.handleFieldChange = this.handleFieldChange.bind(this);
    this.handleCreateBacksound = this.handleCreateBacksound.bind(this);
    this.hasErrorFor = this.hasErrorFor.bind(this);
    this.renderErrorFor = this.renderErrorFor.bind(this);
    this.onMusicChange = this.onMusicChange.bind(this);
  }

  componentDidMount() {
    axios
      .get(`${window.localhost}/wedding`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("Authorization")}`,
        },
      })
      .then((response) => {
        this.setState({
          wedding: response.data,
        });

        // Backsound
        axios
          .get(`${window.localhost}/backsound`, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("Authorization")}`,
            },
          })
          .then((res) => {
            this.setState({
              backsound: res.data,
              isReady: true,
            });
          });
      })
      .catch((error) => {
        // console.log(error.response.data);
        this.props.history.push("/admin-wedding/login");
      });
  }

  handleFieldChange = (event) => {
    this.setState({
      [event.target.name]: event.target.value,
    });
  };

  onMusicChange = (event) => {
    if (event.target.files && event.target.files[0]) {
      console.log(event.target.files[0]);
      this.setState({
        [event.target.name]: event.target.files[0],
      });
    }
  };

  handleCreateBacksound(event) {
    event.preventDefault();

    const formData = new FormData();
    formData.append("music_name", this.state.musicName);
    formData.append("music_url", this.state.musicURL);

    axios
      .post(`${window.localhost}/backsound`, formData, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("Authorization")}`,
        },
      })
      .then((response) => {
        // redirect to the homepage
        var msg = response.data.success;
        if (msg == true) {
          this.setState({
            message: response.data.message,
            musicName: "",
            musicURL: "",
          });
          return this.goToHome();
        }
      })
      .catch((error) => {
        this.setState({
          errors: error.response.data,
        });
      });
  }

  hasErrorFor = (field) => {
    return !!this.state.errors[field];
  };

  renderErrorFor(field) {
    if (this.hasErrorFor(field)) {
      return (
        <span className="invalid-feedback">
          <strong>{this.state.errors[field][0]}</strong>
        </span>
      );
    }
  }

  handleLogout() {
    const getAlert = () => (
      <SweetAlert
        warning
        showCancel
        confirmBtnText="Logout"
        cancelBtnText="Nggak Jadi"
        confirmBtnBsStyle="default"
        cancelBtnBsStyle="danger"
        title="Tunggu..."
        onConfirm={() => this.lemmeLogout()}
        onCancel={() => this.hideAlert()}
        focusCancelBtn
      >
        Apakah Anda yakin ingin Logout?
      </SweetAlert>
    );
    this.setState({
      alert: getAlert(),
    });
  }

  lemmeLogout() {
    axios
      .get(`${window.localhost}/admincre/logout`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("Authorization")}`,
        },
      })
      .then((response) => {
        var msg = response.data.success;
        if (msg == true) {
          localStorage.setItem("Authorization", "LOGOUT");
          this.hideAlert();
          this.goToLogin();
        }
      });
  }

  goToLogin() {
    const getAlert = () => (
      <SweetAlert
        success
        title="Logout Success!"
        onConfirm={() => this.onSuccessLogout()}
        onCancel={this.hideAlert()}
        timeout={2000}
        confirmBtnText="Oke Siap"
      >
        Anda berhasil Logout
      </SweetAlert>
    );
    this.setState({
      alert: getAlert(),
    });
  }

  onSuccessLogout() {
    this.props.history.push("/admin-wedding/login");
  }

  hideAlert() {
    this.setState({
      alert: null,
    });
  }

  confirmDelete(username) {
    const getAlert = () => (
      <SweetAlert
        warning
        showCancel
        confirmBtnText="Hapus Deh"
        cancelBtnText="Nggak Jadi"
        confirmBtnBsStyle="default"
        cancelBtnBsStyle="danger"
        title="Tunggu ..."
        onConfirm={() => this.deleteItem(username)}
        onCancel={() => this.hideAlert()}
        focusCancelBtn
      >
        Kalau udah dihapus, nggak bakal balik lagi.
      </SweetAlert>
    );
    this.setState({
      alert: getAlert(),
    });
  }

  confirmDeleteMusic(id) {
    const getAlert = () => (
      <SweetAlert
        warning
        showCancel
        confirmBtnText="Hapus Deh"
        cancelBtnText="Nggak Jadi"
        confirmBtnBsStyle="default"
        cancelBtnBsStyle="danger"
        title="Tunggu ..."
        onConfirm={() => this.deleteMusic(id)}
        onCancel={() => this.hideAlert()}
        focusCancelBtn
      >
        Kalau udah dihapus, nggak bakal balik lagi.
      </SweetAlert>
    );
    this.setState({
      alert: getAlert(),
    });
  }

  deleteMusic(id) {
    axios
      .delete(`${window.localhost}/backsound/${id}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("Authorization")}`,
        },
      })
      .then((response) => {
        var msg = response.data.success;
        if (msg == true) {
          this.setState({
            message: response.data.message,
          });
          this.hideAlert();
          this.goToHome();
        }
      });
  }

  deleteItem(username) {
    axios
      .delete(`${window.localhost}/wedding/${username}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("Authorization")}`,
        },
      })
      .then((response) => {
        var msg = response.data.success;
        if (msg == true) {
          this.setState({
            message: response.data.message,
          });
          this.hideAlert();
          this.goToHome();
        }
      });
  }

  goToHome() {
    const getAlert = () => (
      <SweetAlert
        success
        title="Success!"
        onConfirm={() => this.onSuccess()}
        onCancel={this.hideAlert()}
        timeout={2000}
        confirmBtnText="Oke Siap"
      >
        {this.state.message}
      </SweetAlert>
    );
    this.setState({
      alert: getAlert(),
    });
  }

  onSuccess() {
    this.setState({
      message: null,
    });
    this.componentDidMount();
    this.hideAlert();
  }

  render() {
    const { wedding, backsound } = this.state;
    const imgpath = `${window.localhost}/img/`;
    const musicpath = `${window.localhost}/music/`;
    if (!this.state.isReady) {
      return <LoadingScreen />;
    } else {
      return (
        <div className="bg-white">
          <nav
            className="navbar navbar-expand-lg navbar-light sticky-top bg-white shadow-sm trans-all"
            id="myNav"
          >
            <div className="container d-flex justify-content-between">
              <Link className="navbar-brand" to="/admin-wedding/index">
                <img
                  src="/img/creatifa-logo-with-text.png"
                  height="30"
                  className="d-inline-block align-top"
                  alt=""
                />
              </Link>

              <button
                onClick={this.handleLogout}
                className="btn btn-outline-pink d-flex border-danger"
              >
                Logout
              </button>
            </div>
          </nav>

          <div className="container-fluid pt-6 overflow-hidden">
            <div className="container my-4 py-3">
              <div className="container rounded-4 p-3 p-sm-4">
                <h2 className="fw-bold">Wedding Dashboard</h2>
                <hr />
                <div className="row">
                  <div className="col">
                    <Link
                      to={`/admin-wedding/create`}
                      className="btn btn-sm btn-outline-primary me-3 mb-2"
                    >
                      Create Wedding
                    </Link>
                    <button
                      type="button"
                      className="btn btn-sm btn-outline-primary me-3 mb-2"
                      data-bs-toggle="modal"
                      data-bs-target="#staticBackdrop"
                    >
                      Tambah Backsound
                    </button>
                  </div>
                </div>

                <div className="row row-cols-sm-4 row-cols-1">
                  {wedding.map((wed, i) => (
                    <div className="col my-3" key={i}>
                      <div className="card h-100 border-0 shadow rounded-4">
                        <div
                          className="wedding-pict w-100 rounded-4 overflow-hidden"
                          style={{
                            backgroundImage: `url(${imgpath}/${wed.username}/${wed.imgslide1})`,
                          }}
                        ></div>
                        <div className="card-body">
                          <p className="text-pink fs-6 font-poppins">
                            {wed.username}
                            {"  "}
                            <span className="badge fw-normal bg-success">
                              {wed.template}
                            </span>
                          </p>
                          <h5 className="card-title">
                            {wed.namesuami} & {wed.nameistri}
                          </h5>
                          <div className="row my-3">
                            <div className="text-center">
                              <div className="grey-line me-2"> </div>
                              <FontAwesomeIcon
                                icon={faHeart}
                                className="fs-4 pink-heart"
                              />
                              <FontAwesomeIcon
                                icon={faHeart}
                                className="fs-4 grey-heart"
                              />
                              <div className="grey-line ms-2"> </div>
                            </div>
                          </div>
                          <div className="row row-cols-3 g-2 d-flex justify-content-between">
                            <div className="col">
                              <div className="dropdown">
                                <button
                                  className="btn btn-outline-warning btn-sm w-100 dropdown-toggle"
                                  type="button"
                                  id="dropdownMenuButton2"
                                  data-bs-toggle="dropdown"
                                  aria-expanded="false"
                                >
                                  Edit
                                </button>
                                <ul
                                  className="dropdown-menu"
                                  aria-labelledby="dropdownMenuButton2"
                                >
                                  <li>
                                    <Link
                                      to={`/admin-wedding/edit/${wed.username}`}
                                      className="dropdown-item"
                                    >
                                      Edit Template
                                    </Link>
                                  </li>
                                  <li>
                                    <Link
                                      to={`/admin-wedding/undangan/${wed.username}`}
                                      className="dropdown-item"
                                    >
                                      Tambah Undangan
                                    </Link>
                                  </li>
                                </ul>
                              </div>
                            </div>
                            <div className="col">
                              <Link
                                to={`/${wed.template}/${wed.username}`}
                                target="_blank"
                                rel="noreferrer"
                                title="Open"
                                className="btn btn-outline-primary btn-sm w-100"
                              >
                                Open
                              </Link>
                            </div>
                            <div className="col">
                              <button
                                title="Delete"
                                className="btn btn-outline-pink btn-sm w-100"
                                onClick={() => this.confirmDelete(wed.username)}
                              >
                                Delete
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>

          <div
            className="modal fade"
            id="staticBackdrop"
            data-bs-backdrop="static"
            data-bs-keyboard="false"
            tabIndex="-1"
            aria-labelledby="staticBackdropLabel"
            aria-hidden="true"
          >
            <div className="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title" id="staticBackdropLabel">
                    Tambah Backsound
                  </h5>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  ></button>
                </div>
                <div className="modal-body bg-light">
                  <div className="table-responsive">
                    <table className="table">
                      <tbody>
                        {backsound.map((bgsnd, i) => (
                          <tr
                            key={i}
                            className="bg-white text-center align-items-center rounded-pill mx-1 shadow-sm"
                          >
                            <td className="align-middle">{bgsnd.music_name}</td>
                            <td className="align-middle">
                              <Backsound
                                musicurl={`${musicpath}/${bgsnd.music_url}`}
                              />
                            </td>
                            <td className="align-middle">
                              <button
                                className="btn btn-sm btn-danger"
                                onClick={() =>
                                  this.confirmDeleteMusic(bgsnd.id)
                                }
                              >
                                <FontAwesomeIcon icon={faTrash} />
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                  <hr />
                  <form onSubmit={this.handleCreateBacksound}>
                    <div className="row row-cols-md-2 row-cols-1 mb-3">
                      <div className="col">
                        <label htmlFor="music_name" className="form-label">
                          Nama Backsound
                        </label>
                        <input
                          type="text"
                          id="musicName"
                          name="musicName"
                          value={this.state.musicName}
                          className={`form-control ${
                            this.hasErrorFor("musicName") ? "is-invalid" : ""
                          }`}
                          onChange={this.handleFieldChange}
                        />
                        {this.renderErrorFor("musicName")}
                      </div>

                      <div className="col">
                        <label htmlFor="musicURL" className="form-label">
                          File Backsound
                        </label>
                        <input
                          type="file"
                          accept="audio/mp3"
                          id="musicURL"
                          name="musicURL"
                          className={`form-control ${
                            this.hasErrorFor("musicURL") ? "is-invalid" : ""
                          }`}
                          onChange={this.onMusicChange}
                        />
                        {this.renderErrorFor("musicURL")}
                      </div>
                    </div>
                    <button type="submit" className="btn btn-primary me-3 px-4">
                      Submit
                    </button>
                  </form>
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    data-bs-dismiss="modal"
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>

          {this.state.alert}
        </div>
      );
    }
  }
}

export default WeddingDashboard;
